import { Spin } from 'antd';
import { PieChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  donut?: boolean;
  color?: string;
  dataSet?: string;
  xColumn?: string;
  yColumn?: string;
}
type Data = Array<{ name: string; value: number }>;

function PieWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id,
    'pie',
    instance.config as Record<string, unknown>,
    instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return (
    <PieChart
      data={data ?? []}
      donut={instance.config.donut ?? true}
      color={instance.config.color}
    />
  );
}

export const pieWidgetDef: WidgetDefinition<Config> = {
  type: 'pie',
  name: 'Pie Chart',
  description: 'Proportional breakdown',
  icon: 'PieChartOutlined',
  category: 'chart',
  defaultTitle: 'Pie Chart',
  defaultConfig: { donut: true },
  minW: 3,
  minH: 4,
  defaultW: 4,
  defaultH: 6,
  component: PieWidget,
  settingsSchema: {
    fields: [
      { key: 'donut', label: 'Donut style', type: 'boolean' },
    ],
  },
};
